import { LandingHeader } from './components/header/landing-header';
import { HeroSection } from './components/hero-section';
import { ConsumerSection } from './components/consumer-section';
import { BusinessSection } from './components/business-section';
import { PricingSection } from './components/pricing-section';
import { FaqSection } from './components/faq-section';
import { ContactSection } from './components/contact-section';
import { LandingFooter } from './components/footer/landing-footer';

export function LandingPage() {
    return (
        <div className="min-h-screen bg-background font-sans text-foreground w-full overflow-x-hidden">
            <LandingHeader />
            <main className="w-full flex flex-col items-stretch">
                <HeroSection />
                <ConsumerSection />
                <BusinessSection />
                <PricingSection />
                <FaqSection />
                <ContactSection />
            </main>
            <LandingFooter />
        </div>
    );
}
